export const AUTHENTICATION_EXPIRED = 'AUTHENTICATION_EXPIRED'
